export class BranchChart {
  branchName: any;
  shifts: any[] = [];
  total: any;
  filled: any;
}
